import React from 'react'

/** icons */

export const GreenTickIconMarketplace = () => (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 32 32">
        <style
            type="text/css"
            dangerouslySetInnerHTML={{
                __html:
                    '\n.sqt0 {\ndisplay: none;\n}\n\n.st1 {\ndisplay: inline;\n}\n\n.st2 {\nfill: #49CC81;\n}\n\n.st3 {\nfill: #49CC81;\n}\n',
            }}
        />
        <g id="Layer_1" className="sqt0">
            <g className="st1">
                <g>
                    <path
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14
				c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
                <g>
                    <path
                        d="M14.1,22c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4c0.4-0.4,1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
				c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-9.9,10C14.6,21.9,14.3,22,14.1,22z"
                    />
                </g>
            </g>
        </g>
        <g id="Layer_2">
            <path
                className="st2"
                d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16c8.8,0,16-7.2,16-16S24.8,0,16,0z M24.7,11.7l-9.9,10
		c-0.2,0.2-0.5,0.3-0.7,0.3c-0.2,0-0.5-0.1-0.6-0.2l-6.1-5.2c-0.4-0.4-0.5-1-0.1-1.4s1-0.5,1.4-0.1l5.4,4.6l9.3-9.3
		c0.4-0.4,1-0.4,1.4,0C25.1,10.7,25.1,11.3,24.7,11.7z"
            />
        </g>
        <g id="Layer_3" className="sqt0">
            <g className="st1">
                <g>
                    <path
                        className="st3"
                        d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2C8.3,2,2,8.3,2,16
				s6.3,14,14,14c7.7,0,14-6.3,14-14S23.7,2,16,2z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const WorkspaceIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
    >
        <path
            d="M13.4.1c-.2-.2-.5-.2-.8-.1H12c-.3 0-.7 0-1 .1C4.9.6 0 5.7 0 12c0 6.6 5.4 12 12 12s12-5.4 12-12C24 5.9 19.4.8 13.4.1zM2 12c0-1 .2-2.1.5-3h2.8c-.4 2-.4 4 0 6H2.5c-.3-.9-.5-2-.5-3zm5.3-3H11v6H7.3c-.4-2-.4-4 0-6zm6.4-5.9c1 1.2 1.8 2.5 2.3 3.9h-3V2.4c.3.2.5.4.7.7zM11 2.4V7H7.9c.7-1.7 1.7-3.3 3.1-4.6zM11 17v4.6c-.3-.3-.6-.5-.8-.8-1-1.2-1.7-2.4-2.3-3.8H11zm2 4.4V17h2.9c-.6 1.6-1.6 3.1-2.9 4.4zm0-6.4V9h3.6c.4 2 .4 4-.1 6H13zm5.7-6h2.8c.3.9.5 2 .5 3s-.2 2.1-.5 3h-2.9c.5-2 .5-4 .1-6zm1.9-2h-2.5C17.7 5.5 17 4.1 16 2.9c2 .8 3.6 2.3 4.6 4.1zM7.9 2.9C7 4.2 6.3 5.6 5.8 7H3.4c1-1.8 2.6-3.3 4.5-4.1zM3.4 17h2.4c.5 1.5 1.2 2.8 2.2 4.1-2-.8-3.6-2.3-4.6-4.1zm12.4 4.2c1-1.3 1.8-2.7 2.3-4.2h2.5c-1.1 1.9-2.8 3.4-4.8 4.2z"
            fill="#ccc"
        />
    </svg>
)
export const MobileIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
    >
        <style>{'.st0{fill:#ccc}'}</style>
        <g id="Devices_Technology" transform="translate(-222 -6907.934)">
            <g id="Group_9620">
                <g id="Group_9617">
                    <path
                        id="Path_4712"
                        className="st0"
                        d="M238 6931.9h-8c-1.7 0-3-1.3-3-3v-18c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v18c0 1.7-1.3 3-3 3zm-8-22c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-18c0-.6-.4-1-1-1h-8z"
                    />
                </g>
                <g id="Group_9618">
                    <path
                        id="Path_4713"
                        className="st0"
                        d="M235 6912.9h-2c-.6 0-1-.4-1-1s.4-1 1-1h2c.6 0 1 .4 1 1s-.4 1-1 1z"
                    />
                </g>
                <g id="Group_9619">
                    <path
                        id="Path_4714"
                        className="st0"
                        d="M234 6928c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
                    />
                </g>
            </g>
        </g>
    </svg>
)

export const PasswordIcons = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
    >
        <style>{'.st0{fill:currentColor}'}</style>
        <g id="Essentials_Interface" transform="translate(-244 -778.001)">
            <g id="Group_9595">
                <g id="Group_9589">
                    <g id="Group_9588">
                        <g id="Group_9583">
                            <path
                                id="Path_4688"
                                className="st0"
                                d="M260.5 793c-1.2 0-2.3-.3-3.4-.8-.5-.2-.7-.9-.4-1.3.2-.5.9-.7 1.3-.4.8.4 1.6.6 2.5.6 3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5c0 .8.2 1.7.6 2.4.3.5.1 1.1-.4 1.4-.5.3-1.1.1-1.4-.4v-.1c-1.9-3.7-.4-8.2 3.3-10.1s8.2-.4 10.1 3.3c1.9 3.7.4 8.2-3.3 10.1-1.1.5-2.2.8-3.4.8z"
                            />
                        </g>
                        <g id="Group_9584">
                            <path
                                id="Path_4689"
                                className="st0"
                                d="M249 802h-4c-.6 0-1-.4-1-1v-2.9c0-.6.4-1 1-1s1 .4 1 1v1.9h3c.6 0 1 .4 1 1s-.4 1-1 1z"
                            />
                        </g>
                        <g id="Group_9585">
                            <path
                                id="Path_4690"
                                className="st0"
                                d="M245 799.1c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7l9.5-9.5c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-9.5 9.5c-.2.2-.4.3-.7.3z"
                            />
                        </g>
                        <g id="Group_9586">
                            <path
                                id="Path_4691"
                                className="st0"
                                d="M255 795c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7l2.6-2.7c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.3l-2.6 2.7c-.2.3-.4.4-.7.4z"
                            />
                        </g>
                        <g id="Group_9587">
                            <path
                                id="Path_4692"
                                className="st0"
                                d="M261.5 786c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm0-2c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z"
                            />
                        </g>
                    </g>
                </g>
                <g id="Group_9590">
                    <path
                        id="Path_4693"
                        className="st0"
                        d="M249 802c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1z"
                    />
                </g>
                <g id="Group_9591">
                    <path
                        id="Path_4694"
                        className="st0"
                        d="M252 799h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1z"
                    />
                </g>
                <g id="Group_9592">
                    <path
                        id="Path_4695"
                        className="st0"
                        d="M255 796h-3c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1s-.4 1-1 1z"
                    />
                </g>
                <g id="Group_9593">
                    <path
                        id="Path_4696"
                        className="st0"
                        d="M252 799c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1z"
                    />
                </g>
                <g id="Group_9594">
                    <path
                        id="Path_4697"
                        className="st0"
                        d="M255 796c-.6 0-1-.4-1-1v-1c0-.6.4-1 1-1s1 .4 1 1v1c0 .6-.4 1-1 1z"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const InfoIcon = () => (
    <svg viewBox="0 0 512 512">
        <path
            fill="currentColor"
            d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
        />
    </svg>
)
export const PasswordOpenIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 18 18"
        xmlSpace="preserve"
    >
        <style>{'.st2{display:inline}'}</style>
        <g
            id="Group_11418"
            transform="translate(-178.584 -877.307)"
            opacity={0.5}
        >
            <g id="Group_11416">
                <g id="Group_11415">
                    <path
                        id="Path_10123"
                        d="M187.5 893.1c-5.7 0-8.8-4.7-8.8-6.6s3.1-6.6 8.8-6.6c5.7 0 8.8 4.7 8.8 6.6 0 1.9-3.1 6.6-8.8 6.6zm0-11.7c-5 0-7.3 4.1-7.3 5.1s2.4 5.1 7.3 5.1c5 0 7.3-4.1 7.3-5.1s-2.3-5.1-7.3-5.1z"
                    />
                </g>
            </g>
            <g id="Group_11417">
                <path
                    id="Path_10124"
                    d="M187.5 890.1c-2 0-3.7-1.6-3.7-3.7s1.6-3.7 3.7-3.7c2 0 3.7 1.6 3.7 3.7s-1.7 3.7-3.7 3.7zm0-5.8c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2z"
                />
            </g>
        </g>
    </svg>
)
export const PasswordHideIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 18 18"
        xmlSpace="preserve"
    >
        <g opacity={0.5}>
            <path
                d="M257.2 889.5c-.1 0-.2 0-.3-.1-3.1-1.6-4.1-4.1-4.1-5.2 0-2 3.1-6.7 9-6.7 3 0 4.5 1.2 5 1.7.3.3.3.8 0 1.1-.3.3-.8.3-1.1 0-.3-.3-1.5-1.3-4-1.3-5.1 0-7.5 4.2-7.5 5.2 0 .4.6 2.4 3.3 3.8.4.2.5.6.3 1 0 .4-.3.5-.6.5zM261.7 891c-.8 0-1.6-.1-2.4-.3-.4-.1-.7-.5-.6-.9.1-.4.5-.7.9-.6.7.2 1.4.2 2.1.2 5.1 0 7.5-4.2 7.5-5.2-.2-.9-.7-1.8-1.3-2.5-.3-.3-.2-.8.1-1 .3-.2.7-.2 1 .1.9.9 1.5 2.1 1.7 3.5-.1 2-3.2 6.7-9 6.7z"
                transform="translate(-252.584 -875.307)"
            />
            <g>
                <path
                    d="M261.7 888c-.4 0-.8-.3-.8-.7 0-.4.3-.8.7-.8 1.2-.1 2.2-1.1 2.3-2.3 0-.4.4-.7.8-.7s.7.4.7.8c-.1 2-1.7 3.6-3.7 3.7z"
                    transform="translate(-252.584 -875.307)"
                />
            </g>
            <g>
                <path
                    d="M254.2 892.5c-.4 0-.7-.3-.7-.7 0-.2.1-.4.2-.5l14.9-14.9c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-14.9 14.9c-.2 0-.4.1-.6.1z"
                    transform="translate(-252.584 -875.307)"
                />
            </g>
            <g>
                <path
                    d="M259.1 886.6c-.3 0-.5-.1-.6-.4-1-1.8-.4-4.1 1.3-5.1 1.4-.8 3.2-.6 4.4.4.3.3.3.8 0 1.1-.3.3-.7.3-1 .1-.9-.8-2.3-.8-3.2.2-.7.7-.8 1.8-.3 2.6.2.4.1.8-.3 1 0 0-.2.1-.3.1z"
                    transform="translate(-252.584 -875.307)"
                />
            </g>
        </g>
    </svg>
)
export const UserIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
    >
        <style>{'.swt0{fill:#ccc}'}</style>
        <g id="Group_9609" transform="translate(-182 -4511)">
            <g id="Group_9607">
                <path
                    id="Path_4704"
                    className="swt0"
                    d="M194 4525c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm0-12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5z"
                />
            </g>
            <g id="Group_9608">
                <path
                    id="Path_4705"
                    className="swt0"
                    d="M203 4535h-18c-.6 0-1-.4-1-1v-.7c0-5.1 4.6-9.3 10-9.3s10 4.3 10 9.3v.7c0 .6-.4 1-1 1zm-17-2h16c-.2-3.8-3.8-7-8-7s-7.8 3.2-8 7z"
                />
            </g>
        </g>
    </svg>
)
export const EmailICon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
    >
        <style>{'.str0{fill:currentColor}'}</style>
        <g id="Communications" transform="translate(-222.999 -2665.855)">
            <g id="Group_9606">
                <g id="Group_9596">
                    <path
                        id="Path_4698"
                        className="str0"
                        d="M235 2683.9c-.2 0-.3 0-.5-.1l-11-6c-.5-.3-.7-.9-.4-1.3.3-.5.9-.7 1.3-.4l10.5 5.7 10.5-5.7c.5-.3 1.1-.1 1.4.4s.1 1.1-.4 1.4l-11 6c-.1-.1-.2 0-.4 0z"
                    />
                </g>
                <g id="Group_9602">
                    <g id="Group_9601">
                        <g id="Group_9598">
                            <g id="Group_9597">
                                <path
                                    id="Path_4699"
                                    className="str0"
                                    d="M244 2689.9h-18c-1.7 0-3-1.3-3-3v-10c0-.6.4-1 1-1s1 .4 1 1v10c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-10c0-.6.4-1 1-1s1 .4 1 1v10c0 1.6-1.3 3-3 3z"
                                />
                            </g>
                        </g>
                        <g id="Group_9599">
                            <path
                                id="Path_4700"
                                className="str0"
                                d="M246 2677.9c-.2 0-.5-.1-.7-.3l-3.3-3c-.4-.4-.5-1-.1-1.4.4-.4 1-.5 1.4-.1l3.3 3c.4.4.4 1 .1 1.4-.2.2-.4.4-.7.4z"
                            />
                        </g>
                        <g id="Group_9600">
                            <path
                                id="Path_4701"
                                className="str0"
                                d="M224 2677.9c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7l3.3-3c.4-.4 1-.3 1.4.1.4.4.3 1-.1 1.4l-3.3 3c-.1.1-.4.2-.6.2z"
                            />
                        </g>
                    </g>
                </g>
                <g id="Group_9605">
                    <g id="Group_9603">
                        <path
                            id="Path_4702"
                            className="str0"
                            d="M235 2674.9c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
                        />
                    </g>
                    <g id="Group_9604">
                        <path
                            id="Path_4703"
                            className="str0"
                            d="M235 2677.9c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6v.2c.1 1.2-.2 2.3-1 3.2-.7.7-1.8.9-2.7.5-.8-.3-1.3-1-1.3-1.8v-3.1c0-.6.4-1 1-1s1 .4 1 1v3.1h.6c.4-.5.5-1.2.4-1.8v-.3c0-2.2-1.8-4-4-4s-4 1.8-4 4 1.8 4 4 4c.6 0 1 .4 1 1s-.4 1-1 1z"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const DropdownIcon = () => (
    <svg
        id="Group_9262"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16.2 16.2"
        xmlSpace="preserve"
    >
        <style>{'.st00{fill:currentColor}'}</style>
        <g id="Group_8957">
            <path
                id="Path_4530"
                className="st00"
                d="M8.1 16.2C3.6 16.2 0 12.6 0 8.1S3.6 0 8.1 0s8.1 3.6 8.1 8.1-3.6 8.1-8.1 8.1zm0-14.8a6.7 6.7 0 100 13.4 6.7 6.7 0 000-13.4z"
            />
        </g>
        <g id="Group_8958" transform="translate(4.723 6.073)">
            <path
                id="Path_4531"
                className="st00"
                d="M3.4 4c-.2 0-.4 0-.5-.2L.2 1.1C-.1.8 0 .4.2.1c.3-.1.7-.1 1 .1l2.2 2.2L5.6.2c.3-.3.7-.3 1 0s.3.7 0 1L3.8 3.8c-.1.2-.2.2-.4.2z"
            />
        </g>
    </svg>
)
export const ErrorIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
        xmlSpace="preserve"
    >
        <style>{'.st10{fill:#fc2a2a}'}</style>
        <g id="Group_10972" transform="translate(-1086 -482)">
            <g id="Group_10695" transform="translate(1086 482)">
                <path
                    id="Path_7875"
                    className="st10"
                    d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 1.3A6.7 6.7 0 1014.7 8c0-3.7-3-6.7-6.7-6.7z"
                />
            </g>
            <g id="Group_10696" transform="translate(1093.333 485.333)">
                <path
                    id="Path_7876"
                    className="st10"
                    d="M.7 6.7C.3 6.7 0 6.4 0 6V.7C0 .3.3 0 .6 0c.4 0 .7.2.7.6V6c0 .4-.3.7-.6.7z"
                />
            </g>
            <g id="Group_10697" transform="translate(1093.333 493.342)">
                <path
                    id="Path_7877"
                    className="st10"
                    d="M.7 1.3C.3 1.3 0 1 0 .7 0 .5.1.4.2.2c.3-.2.7-.2.9 0 .1.1.2.3.2.5 0 .3-.3.6-.6.6z"
                />
            </g>
        </g>
    </svg>
)
export const NextIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 12 14">
        <path d="M12 7L0 14V0l12 7z" fill="currentColor" />
    </svg>
)

export const CompanyIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
    >
        <style>{'.st0{fill:#ccc}'}</style>
        <g id="Group_9629" transform="translate(5.986 -20.85)">
            <path
                id="Path_4721"
                className="st0"
                d="M17.8 43.8H-5.8v-1.5h1.5V30.9h3V28h5.9v-6h8.9v3h3v17.3H18l-.2 1.5zM6 26.5v15.8h1.5v-2.9h5.9v2.9h1.4V26.5H6zm-8.8 5.9v9.9h7.4v-9.9h-7.4zm14.7-9H6V25h5.9v-1.6zm-7.4 6H.1v1.4h4.4v-1.4zM9 42.3h2.9v-1.4H9v1.4z"
            />
            <path
                id="Path_4722"
                className="st0"
                d="M13.4 28.8v1.4H7.5v-1.4h5.9z"
            />
            <path
                id="Path_4723"
                className="st0"
                d="M13.4 34.1H7.5v-1.5h5.9v1.5z"
            />
            <path
                id="Path_4724"
                className="st0"
                d="M7.5 36.4h5.9v1.4H7.5v-1.4z"
            />
            <path
                id="Path_4725"
                className="st0"
                d="M-1.4 34.9v-1.4H3v1.4h-4.4z"
            />
            <path
                id="Path_4726"
                className="st0"
                d="M-1.4 37.9v-1.4H3v1.4h-4.4z"
            />
            <path
                id="Path_4727"
                className="st0"
                d="M-1.4 40.8v-1.4H3v1.4h-4.4z"
            />
        </g>
    </svg>
)

export const EmployeeSizeIcon = () => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
    >
        <style>{'.st0{fill:#ccc}'}</style>
        <g id="Group_9616" transform="translate(-182 -4563)">
            <g id="Group_9610" transform="translate(202.059 4565.36)">
                <path
                    id="Path_4706"
                    className="st0"
                    d="M-.3 9.6c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9c1.6 0 2.9 1.3 2.9 2.9.1 1.6-1.2 2.9-2.9 2.9zm0-3.9c-.5 0-1 .4-1 1 0 .5.4 1 1 1 .5 0 1-.4 1-1 0-.5-.4-1-1-1z"
                />
            </g>
            <g id="Group_9611" transform="translate(191.439 4563)">
                <path
                    id="Path_4707"
                    className="st0"
                    d="M2.6 12c-2.2 0-3.9-1.7-3.9-3.9S.4 4.2 2.6 4.2s3.9 1.7 3.9 3.9S4.7 12 2.6 12zm0-5.8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c-.1-1.2-1-2-2-2z"
                />
            </g>
            <g id="Group_9612" transform="translate(200.879 4572.397)">
                <path
                    id="Path_4708"
                    className="st0"
                    d="M3.9 9.4H-2c-.5 0-1-.4-1-1v-.7c-.1-2.2 1.6-4 3.7-4.1 2.2-.1 4 1.6 4.1 3.7V8.5c0 .5-.4.9-.9.9zM-1 7.5h3.9C2.9 6.4 2 5.6 1 5.6c-1.1-.1-2 .8-2 1.9z"
                />
            </g>
            <g id="Group_9613" transform="translate(183.18 4565.36)">
                <path
                    id="Path_4709"
                    className="st0"
                    d="M3 9.6C1.4 9.6.1 8.3.1 6.7S1.4 3.8 3 3.8c1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9zm0-3.9c-.5 0-1 .4-1 1 0 .5.4 1 1 1 .5 0 1-.4 1-1 0-.5-.4-1-1-1z"
                />
            </g>
            <g id="Group_9614" transform="translate(182 4572.397)">
                <path
                    id="Path_4710"
                    className="st0"
                    d="M7.1 9.4H1.3c-.5 0-1-.4-1-1v-.7C.2 5.5 1.9 3.7 4 3.6c2.2-.1 4 1.6 4.1 3.7V8.5c0 .5-.4.9-1 .9zM2.3 7.5h3.9c0-1.1-.9-1.9-1.9-1.9-1.2-.1-2 .8-2 1.9z"
                />
            </g>
            <g id="Group_9615" transform="translate(190.26 4572.397)">
                <path
                    id="Path_4711"
                    className="st0"
                    d="M7.6 10.4H-.2c-.5 0-1-.4-1-1v-.7c-.1-2.7 1.9-5 4.6-5.1s5 1.9 5.1 4.6v1.2c.1.6-.3 1-.9 1zM.8 8.5h5.8c0-1.6-1.3-2.9-2.9-3-1.5 0-2.8 1.2-2.9 3 0-.1 0-.1 0 0z"
                />
            </g>
        </g>
    </svg>
)

export const TeamsIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
        <style>{'.st01{fill:#5558af}'}</style>
        <g id="teams" transform="translate(-202 -202)">
            <circle
                id="Ellipse_494"
                className="st01"
                cx={234}
                cy={234}
                r={32}
            />
            <g id="Group_8807" transform="translate(215.2 215.4)">
                <path
                    id="Path_4391"
                    d="M31.5 14.1c.3.3.7.5 1.1.7.8.3 1.8.3 2.6 0s1.4-1 1.7-1.7c.3-.8.3-1.8 0-2.6s-1-1.4-1.7-1.7c-.8-.3-1.8-.3-2.6 0s-1.4 1-1.7 1.7c-.3.8-.3 1.8 0 2.6 0 .3.3.7.6 1zm-1 3.1v10.1h1.7c.6 0 1.1-.1 1.7-.1.6-.1 1.1-.3 1.6-.5.5-.3.9-.6 1.2-1.1.3-.5.5-1.1.5-1.7v-6.6l-6.7-.1zM25.1 13c.4 0 .9-.1 1.3-.3.8-.3 1.4-1 1.7-1.7.3-.8.3-1.8 0-2.6s-1-1.4-1.7-1.7c-.4-.2-.9-.2-1.3-.3-.4 0-.9.1-1.3.3-.3.1-.4.3-.8.5v5.1c.4.2.5.4.8.5.4.1.9.2 1.3.2zM23 29.9c.3.1.6.1.9.2.3.1.7.1 1 .1.5 0 1-.1 1.5-.1.5-.1 1-.3 1.5-.5.4-.3.8-.6 1.1-1.1.3-.5.4-1.1.4-1.7V15.1h-6.3L23 29.9zM0 33.1l21.7 3.7V0L0 3.7v29.4z"
                    fill="#fff"
                />
            </g>
            <path
                id="Path_4392"
                className="st01"
                d="M231.1 226.7l-10.1.6v2.3l3.7-.1v10.7l2.5.1v-11l3.7-.1.2-2.5z"
            />
        </g>
    </svg>
)

export const WidgetIcon = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
        <style>{'.st11{fill:#fff}'}</style>
        <g id="widget" transform="translate(-11.5 -11.5)">
            <circle
                id="Ellipse_495"
                cx={43.5}
                cy={43.5}
                r={32}
                fill="#3789e1"
            />
            <g id="Group_9173" transform="translate(28.636 28.623)">
                <path
                    id="Path_4519"
                    className="st11"
                    d="M17.6 24.8h2.1v.7c0 .5.4 1 1 1 .3 0 .2 0 3.2-1.7h.5c.9 0 1.7-.8 1.7-1.7V19c0-.9-.8-1.7-1.7-1.7h-6.8c-.9 0-1.7.8-1.7 1.7v4.1c0 .9.8 1.7 1.7 1.7zm.2-5.5h6.4v3.6c-1 0-.5-.1-2.6 1 0-.5-.4-1-.9-1h-2.9v-3.6z"
                />
                <path
                    id="Path_4520"
                    className="st11"
                    d="M28.7 0H.9C.4 0 0 .4 0 .9v27.8c0 .5.4.9.9.9h27.8c.5 0 .9-.4.9-.9V.9c0-.5-.4-.9-.9-.9zm-.9 27.8H1.9V8.7h25.9v19.1zm0-21H1.9v-5h25.9v5z"
                />
                <path
                    id="Path_4521"
                    className="st11"
                    d="M14.5 5.3h10.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H14.5c-.5 0-.9.4-.9.9s.4.9.9.9z"
                />
                <circle
                    id="Ellipse_496"
                    className="st11"
                    cx={5.2}
                    cy={4.4}
                    r={0.9}
                />
                <circle
                    id="Ellipse_497"
                    className="st11"
                    cx={8.2}
                    cy={4.4}
                    r={0.9}
                />
                <circle
                    id="Ellipse_498"
                    className="st11"
                    cx={11.3}
                    cy={4.4}
                    r={0.9}
                />
            </g>
        </g>
    </svg>
)

export const SlackIconCC = () => (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 64 64" xmlSpace="preserve">
        <style>
            {
                '.st11{fill:#e01e5a}.st21{fill:#36c5f0}.st31{fill:#2eb67d}.st41{fill:#ecb22e}'
            }
        </style>
        <g id="slack" transform="translate(-60.1 -58.5)">
            <circle
                id="Ellipse_493"
                cx={92.1}
                cy={90.5}
                r={32}
                fill="#4a134a"
            />
            <g id="Group_8796" transform="translate(75.538 73.78)">
                <g id="Group_8792" transform="translate(0 17.145)">
                    <path
                        id="Path_4374"
                        className="st11"
                        d="M6.8 3.4c0 1.9-1.5 3.4-3.4 3.4S0 5.3 0 3.4 1.5 0 3.4 0h3.4v3.4z"
                    />
                    <path
                        id="Path_4375"
                        className="st11"
                        d="M8.6 3.4C8.6 1.5 10.1 0 12 0s3.4 1.5 3.4 3.4V12c0 1.9-1.5 3.4-3.4 3.4S8.6 13.9 8.6 12V3.4z"
                    />
                </g>
                <g id="Group_8793">
                    <path
                        id="Path_4376"
                        className="st21"
                        d="M12 6.8c-1.9 0-3.4-1.5-3.4-3.4S10.1 0 12 0s3.4 1.5 3.4 3.4v3.4H12z"
                    />
                    <path
                        id="Path_4377"
                        className="st21"
                        d="M12 8.6c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4H3.4C1.5 15.4 0 13.9 0 12s1.5-3.4 3.4-3.4H12z"
                    />
                </g>
                <g id="Group_8794" transform="translate(17.145)">
                    <path
                        id="Path_4378"
                        className="st31"
                        d="M8.6 12c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4-1.5 3.4-3.4 3.4H8.6V12z"
                    />
                    <path
                        id="Path_4379"
                        className="st31"
                        d="M6.8 12c0 1.9-1.5 3.4-3.4 3.4S0 13.9 0 12V3.4C0 1.5 1.5 0 3.4 0s3.4 1.5 3.4 3.4V12z"
                    />
                </g>
                <g id="Group_8795" transform="translate(17.145 17.145)">
                    <path
                        id="Path_4380"
                        className="st41"
                        d="M3.4 8.6c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4S0 13.9 0 12V8.6h3.4z"
                    />
                    <path
                        id="Path_4381"
                        className="st41"
                        d="M3.4 6.8C1.5 6.8 0 5.3 0 3.4S1.5 0 3.4 0H12c1.9 0 3.4 1.5 3.4 3.4S13.9 6.8 12 6.8H3.4z"
                    />
                </g>
            </g>
        </g>
    </svg>
)
export const ThumbsUpSvg = props => {
    return (
        <svg
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 84 84"
            xmlSpace="preserve"
            {...props}
        >
            <style>{'.st1{fill:#3da27e}'}</style>
            <g id="Group_8598" transform="translate(-876.713 -198.713)">
                <path
                    id="Rectangle_192"
                    d="M918.7 198.7c23.2 0 42 18.8 42 42s-18.8 42-42 42-42-18.8-42-42 18.8-42 42-42z"
                    fill="#c0f6e3"
                />
                <g id="Group_11944" transform="translate(896.015 219.35)">
                    <path
                        id="Path_10131"
                        className="st1"
                        d="M44.2 26c.1-1.5-.6-2.9-1.8-3.8 1.1-1 1.8-2.4 1.8-3.8.1-2.6-1.9-4.7-4.5-4.8H28.8V6.7c0-5.3-4.4-6.7-6.7-6.7-.5 0-1 .4-1 1v7.4l-3.6 5.4-4.1 3.1v-2.4c0-.5-.4-1-1-1H1c-.5 0-1 .4-1 1v26.9c0 .5.4 1 1 1h11.5c.5 0 1-.4 1-1v-.7c.7.9 1.7 1.5 2.9 1.7h21.1c1.5.1 3-.5 4-1.7 1.4-1.8 1.6-4.2.5-6.2 1.3-.2 2.2-1.3 2.1-2.6.1-1.3-.4-2.5-1.3-3.4 1-.6 1.5-1.6 1.4-2.5zM11.5 40.4H1.9v-25h9.6v25zm26-13.5c-.5 0-1 .4-1 1s.4 1 1 1h1.9c1.5-.1 2.8 1.1 2.9 2.6v.3c0 .7-.4 1-2.9 1h-3.8c-.5 0-1 .4-1 1s.4 1 1 1h3.8c.9 0 1.4 1.3 1.4 2.5 0 .8-.3 1.6-.8 2.3-.7.7-1.6 1.1-2.6 1H16.3c-.8 0-2.2-1.8-2.9-3.1v-18l5.4-4.1c.1-.1.2-.1.2-.2l3.8-5.8c.2-.4.3-.6.3-.7V2c2.3.3 4 2.4 3.8 4.7v7.7c0 .5.4 1 1 1h11.5c1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9h-3.1c-.5 0-1 .4-1 1s.4 1 1 1h3.1c1.5-.1 2.8 1.1 2.9 2.6v.3c0 .7-.4 1-2.9 1l-1.9-.2z"
                    />
                    <path
                        id="Path_10132"
                        className="st1"
                        d="M6.6 37.5c1.1.1 2-.7 2.1-1.8.1-1.1-.7-2-1.8-2.1-1.1-.1-2 .7-2.1 1.8-.1 1.1.7 2 1.8 2.1z"
                    />
                </g>
            </g>
        </svg>
    )
}

export const CountryIcon = props => {
    return (
        <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 24.3 24.3"
      xmlSpace="preserve"
    >
      <style>{".countryIcon{fill:#ccc}"}</style>
      <path
        className="countryIcon"
        d="M24.3 11.4c0-.1 0-.3-.1-.4 0-.3-.1-.6-.1-.9-.5-2.7-1.9-5.2-3.9-7-1.7-1.5-3.8-2.5-6-2.9-.3 0-.6-.1-.8-.1H11c-.3 0-.6.1-.9.1-2.6.4-4.8 1.6-6.6 3.4C1.7 5.4.6 7.6.2 10.1c0 .3-.1.5-.1.8 0 .1 0 .3-.1.4v1.5c0 .1 0 .3.1.4 0 .3.1.6.1.9.5 2.7 1.8 5.2 3.9 6.9 1.8 1.6 4 2.7 6.4 3 .6.1 1.2.1 1.7.1 2.8 0 5.6-1 7.7-2.9 2.2-1.8 3.6-4.3 4.1-7 .1-.3.1-.6.1-.8 0-.1 0-.3.1-.4V12.7l.1-1.3zm-12.1-10c5.9 0 10.7 4.8 10.7 10.7 0 5.9-4.8 10.7-10.7 10.7-5.9 0-10.7-4.8-10.7-10.7 0-5.9 4.7-10.7 10.7-10.7z"
      />
      <path
        className="countryIcon"
        d="M7.9 14.1c1.1 1.8 2.3 3.5 3.7 5.1l.2.2c.1.1.2.1.4.1s.5-.1.6-.3l.5-.7c.6-.7 1.2-1.5 1.7-2.3.9-1.2 1.7-2.5 2.3-3.8.3-.7.5-1.4.5-2.2h-.2.1V10v-.3c-.2-1.6-1.1-3-2.4-3.9-2.5-1.8-6-1.2-7.8 1.4-1.1 1.4-1.3 3.4-.6 5 .3.6.6 1.3 1 1.9zm4.2 3.8zm.1-.2l-.3-.4c-.3-.4-.5-.7-.8-1.1-1-1.3-1.9-2.7-2.6-4.2-.1-.3-.2-.5-.3-.8-.6-2.2.8-4.4 2.9-5 .3-.1.7-.1 1-.1h.1c2.3 0 4.2 1.9 4.2 4.1 0 .5-.1 1-.4 1.5-.5 1.2-1.2 2.3-2 3.3-.4.6-.9 1.2-1.3 1.8-.2.4-.3.6-.5.9 0-.1 0-.1 0 0z"
      />
      <path
        className="countryIcon"
        d="M15.6 10.4c0-1.9-1.5-3.5-3.5-3.5-.9 0-1.8.4-2.4 1-.7.7-1 1.5-1 2.5 0 .9.4 1.8 1 2.5.7.7 1.5 1 2.5 1 .9 0 1.8-.4 2.4-1 .7-.7 1-1.6 1-2.5zm-3.4 2c-.6 0-1.1-.2-1.5-.6-.4-.4-.6-.9-.6-1.4s.2-1.1.6-1.5c.4-.4.9-.6 1.4-.6.5 0 1.1.2 1.4.6.4.4.6.9.6 1.4.1 1.2-.8 2.1-1.9 2.1z"
      />
    </svg>
    )
}
